import styled from 'styled-components'

export const GridInfinityScrollStyled = styled.div`
	overflow-y: scroll;
	width: 100%;
`

export const GridInfinityScrollRefStyled = styled.div`
	display: block;
	height: 5px;
`
